/** ISO 3166-1 alpha-2 + common name (restcountries snapshot). Used for profile country picker. */
export const INTERNATIONAL_COUNTRY_VALUE = '' as const;

const RAW_ENTRIES: readonly [code: string, name: string][] = [
  ['AF', "Afghanistan"],
  ['AX', "Åland Islands"],
  ['AL', "Albania"],
  ['DZ', "Algeria"],
  ['AS', "American Samoa"],
  ['AD', "Andorra"],
  ['AO', "Angola"],
  ['AI', "Anguilla"],
  ['AQ', "Antarctica"],
  ['AG', "Antigua and Barbuda"],
  ['AR', "Argentina"],
  ['AM', "Armenia"],
  ['AW', "Aruba"],
  ['AU', "Australia"],
  ['AT', "Austria"],
  ['AZ', "Azerbaijan"],
  ['BS', "Bahamas"],
  ['BH', "Bahrain"],
  ['BD', "Bangladesh"],
  ['BB', "Barbados"],
  ['BY', "Belarus"],
  ['BE', "Belgium"],
  ['BZ', "Belize"],
  ['BJ', "Benin"],
  ['BM', "Bermuda"],
  ['BT', "Bhutan"],
  ['BO', "Bolivia"],
  ['BA', "Bosnia and Herzegovina"],
  ['BW', "Botswana"],
  ['BV', "Bouvet Island"],
  ['BR', "Brazil"],
  ['IO', "British Indian Ocean Territory"],
  ['VG', "British Virgin Islands"],
  ['BN', "Brunei"],
  ['BG', "Bulgaria"],
  ['BF', "Burkina Faso"],
  ['BI', "Burundi"],
  ['KH', "Cambodia"],
  ['CM', "Cameroon"],
  ['CA', "Canada"],
  ['CV', "Cape Verde"],
  ['BQ', "Caribbean Netherlands"],
  ['KY', "Cayman Islands"],
  ['CF', "Central African Republic"],
  ['TD', "Chad"],
  ['CL', "Chile"],
  ['CN', "China"],
  ['CX', "Christmas Island"],
  ['CC', "Cocos (Keeling) Islands"],
  ['CO', "Colombia"],
  ['KM', "Comoros"],
  ['CK', "Cook Islands"],
  ['CR', "Costa Rica"],
  ['HR', "Croatia"],
  ['CU', "Cuba"],
  ['CW', "Curaçao"],
  ['CY', "Cyprus"],
  ['CZ', "Czechia"],
  ['DK', "Denmark"],
  ['DJ', "Djibouti"],
  ['DM', "Dominica"],
  ['DO', "Dominican Republic"],
  ['CD', "DR Congo"],
  ['EC', "Ecuador"],
  ['EG', "Egypt"],
  ['SV', "El Salvador"],
  ['GQ', "Equatorial Guinea"],
  ['ER', "Eritrea"],
  ['EE', "Estonia"],
  ['SZ', "Eswatini"],
  ['ET', "Ethiopia"],
  ['FK', "Falkland Islands"],
  ['FO', "Faroe Islands"],
  ['FJ', "Fiji"],
  ['FI', "Finland"],
  ['FR', "France"],
  ['GF', "French Guiana"],
  ['PF', "French Polynesia"],
  ['TF', "French Southern and Antarctic Lands"],
  ['GA', "Gabon"],
  ['GM', "Gambia"],
  ['GE', "Georgia"],
  ['DE', "Germany"],
  ['GH', "Ghana"],
  ['GI', "Gibraltar"],
  ['GR', "Greece"],
  ['GL', "Greenland"],
  ['GD', "Grenada"],
  ['GP', "Guadeloupe"],
  ['GU', "Guam"],
  ['GT', "Guatemala"],
  ['GG', "Guernsey"],
  ['GN', "Guinea"],
  ['GW', "Guinea-Bissau"],
  ['GY', "Guyana"],
  ['HT', "Haiti"],
  ['HM', "Heard Island and McDonald Islands"],
  ['HN', "Honduras"],
  ['HK', "Hong Kong"],
  ['HU', "Hungary"],
  ['IS', "Iceland"],
  ['IN', "India"],
  ['ID', "Indonesia"],
  ['IR', "Iran"],
  ['IQ', "Iraq"],
  ['IE', "Ireland"],
  ['IM', "Isle of Man"],
  ['IL', "Israel"],
  ['IT', "Italy"],
  ['CI', "Ivory Coast"],
  ['JM', "Jamaica"],
  ['JP', "Japan"],
  ['JE', "Jersey"],
  ['JO', "Jordan"],
  ['KZ', "Kazakhstan"],
  ['KE', "Kenya"],
  ['KI', "Kiribati"],
  ['XK', "Kosovo"],
  ['KW', "Kuwait"],
  ['KG', "Kyrgyzstan"],
  ['LA', "Laos"],
  ['LV', "Latvia"],
  ['LB', "Lebanon"],
  ['LS', "Lesotho"],
  ['LR', "Liberia"],
  ['LY', "Libya"],
  ['LI', "Liechtenstein"],
  ['LT', "Lithuania"],
  ['LU', "Luxembourg"],
  ['MO', "Macau"],
  ['MG', "Madagascar"],
  ['MW', "Malawi"],
  ['MY', "Malaysia"],
  ['MV', "Maldives"],
  ['ML', "Mali"],
  ['MT', "Malta"],
  ['MH', "Marshall Islands"],
  ['MQ', "Martinique"],
  ['MR', "Mauritania"],
  ['MU', "Mauritius"],
  ['YT', "Mayotte"],
  ['MX', "Mexico"],
  ['FM', "Micronesia"],
  ['MD', "Moldova"],
  ['MC', "Monaco"],
  ['MN', "Mongolia"],
  ['ME', "Montenegro"],
  ['MS', "Montserrat"],
  ['MA', "Morocco"],
  ['MZ', "Mozambique"],
  ['MM', "Myanmar"],
  ['NA', "Namibia"],
  ['NR', "Nauru"],
  ['NP', "Nepal"],
  ['NL', "Netherlands"],
  ['NC', "New Caledonia"],
  ['NZ', "New Zealand"],
  ['NI', "Nicaragua"],
  ['NE', "Niger"],
  ['NG', "Nigeria"],
  ['NU', "Niue"],
  ['NF', "Norfolk Island"],
  ['KP', "North Korea"],
  ['MK', "North Macedonia"],
  ['MP', "Northern Mariana Islands"],
  ['NO', "Norway"],
  ['OM', "Oman"],
  ['PK', "Pakistan"],
  ['PW', "Palau"],
  ['PS', "Palestine"],
  ['PA', "Panama"],
  ['PG', "Papua New Guinea"],
  ['PY', "Paraguay"],
  ['PE', "Peru"],
  ['PH', "Philippines"],
  ['PN', "Pitcairn Islands"],
  ['PL', "Poland"],
  ['PT', "Portugal"],
  ['PR', "Puerto Rico"],
  ['QA', "Qatar"],
  ['CG', "Republic of the Congo"],
  ['RE', "Réunion"],
  ['RO', "Romania"],
  ['RU', "Russia"],
  ['RW', "Rwanda"],
  ['BL', "Saint Barthélemy"],
  ['SH', "Saint Helena, Ascension and Tristan da Cunha"],
  ['KN', "Saint Kitts and Nevis"],
  ['LC', "Saint Lucia"],
  ['MF', "Saint Martin"],
  ['PM', "Saint Pierre and Miquelon"],
  ['VC', "Saint Vincent and the Grenadines"],
  ['WS', "Samoa"],
  ['SM', "San Marino"],
  ['ST', "São Tomé and Príncipe"],
  ['SA', "Saudi Arabia"],
  ['SN', "Senegal"],
  ['RS', "Serbia"],
  ['SC', "Seychelles"],
  ['SL', "Sierra Leone"],
  ['SG', "Singapore"],
  ['SX', "Sint Maarten"],
  ['SK', "Slovakia"],
  ['SI', "Slovenia"],
  ['SB', "Solomon Islands"],
  ['SO', "Somalia"],
  ['ZA', "South Africa"],
  ['GS', "South Georgia"],
  ['KR', "South Korea"],
  ['SS', "South Sudan"],
  ['ES', "Spain"],
  ['LK', "Sri Lanka"],
  ['SD', "Sudan"],
  ['SR', "Suriname"],
  ['SJ', "Svalbard and Jan Mayen"],
  ['SE', "Sweden"],
  ['CH', "Switzerland"],
  ['SY', "Syria"],
  ['TW', "Taiwan"],
  ['TJ', "Tajikistan"],
  ['TZ', "Tanzania"],
  ['TH', "Thailand"],
  ['TL', "Timor-Leste"],
  ['TG', "Togo"],
  ['TK', "Tokelau"],
  ['TO', "Tonga"],
  ['TT', "Trinidad and Tobago"],
  ['TN', "Tunisia"],
  ['TR', "Turkey"],
  ['TM', "Turkmenistan"],
  ['TC', "Turks and Caicos Islands"],
  ['TV', "Tuvalu"],
  ['UG', "Uganda"],
  ['UA', "Ukraine"],
  ['AE', "United Arab Emirates"],
  ['GB', "United Kingdom"],
  ['US', "United States"],
  ['UM', "United States Minor Outlying Islands"],
  ['VI', "United States Virgin Islands"],
  ['UY', "Uruguay"],
  ['UZ', "Uzbekistan"],
  ['VU', "Vanuatu"],
  ['VA', "Vatican City"],
  ['VE', "Venezuela"],
  ['VN', "Vietnam"],
  ['WF', "Wallis and Futuna"],
  ['EH', "Western Sahara"],
  ['YE', "Yemen"],
  ['ZM', "Zambia"],
  ['ZW', "Zimbabwe"],
];

const _codeSet = new Set(RAW_ENTRIES.map((e) => e[0]));
export const PROFILE_COUNTRY_CODE_SET: ReadonlySet<string> = _codeSet;

export function alpha2ToRegionalFlagEmoji(code: string): string {
  const u = code.toUpperCase();
  if (u.length !== 2 || ![...u].every((c) => c >= 'A' && c <= 'Z')) return '🌐';
  const A = 0x1f1e6;
  return String.fromCodePoint(
    A + (u.charCodeAt(0) - 65),
    A + (u.charCodeAt(1) - 65),
  );
}

export type ProfileCountryOption = {
  value: string;
  label: string;
  flag: string;
};

export function getProfileCountryOptions(): ProfileCountryOption[] {
  const intl: ProfileCountryOption = {
    value: INTERNATIONAL_COUNTRY_VALUE,
    label: 'International',
    flag: '🌐',
  };
  return [
    intl,
    ...RAW_ENTRIES.map(([code, name]) => ({
      value: code,
      label: name,
      flag: alpha2ToRegionalFlagEmoji(code),
    })),
  ];
}

export function normalizeStoredCountryCode(raw: unknown): string | null {
  if (raw == null) return null;
  if (typeof raw !== 'string') return null;
  const t = raw.trim();
  if (t === '') return null;
  const u = t.toUpperCase();
  return PROFILE_COUNTRY_CODE_SET.has(u) ? u : null;
}

export function countryLabelForCode(code: string | null): string {
  if (code == null) return 'International';
  const row = RAW_ENTRIES.find((e) => e[0] === code);
  return row ? row[1] : 'International';
}
